var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_104",
    "data-name": 104,
    className: "cls-2",
    d: "M19.52,2.84C23.14-1.17,37.59,6.6,42.05,9A77.64,77.64,0,0,1,69.79,34.45c6.84,10.33,14.32,25.36,11.17,38-4.13,16.58-23.9,29-32.77,24.58C39.57,92.73,48.38,76,40,47.9,32,21.05,15.31,7.5,19.52,2.84Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cat_301"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: -59,
    width: 100,
    height: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog104);
export default __webpack_public_path__ + "static/media/dog_104.058b7fd8f99d7860f4dcc9d1809525f9.svg";
export { ForwardRef as ReactComponent };